export let SiteIndexProgressDataHooks = /*#__PURE__*/function (SiteIndexProgressDataHooks) {
  SiteIndexProgressDataHooks["SiteIndexProgressTable"] = "site-index-progress-table";
  SiteIndexProgressDataHooks["SiteIndexProgressTableTitle"] = "site-index-progress-table-title";
  SiteIndexProgressDataHooks["SiteIndexProgressTableToolbar"] = "site-index-progress-table-toolbar";
  SiteIndexProgressDataHooks["TypeColumn"] = "site-index-progress-type-column";
  SiteIndexProgressDataHooks["IndexingProgressColumn"] = "site-index-progress-indexing-progress-column";
  SiteIndexProgressDataHooks["StatusColumn"] = "site-index-progress-status-column";
  SiteIndexProgressDataHooks["ProgressBar"] = "site-index-progress-progress-bar";
  SiteIndexProgressDataHooks["DocName"] = "site-index-progress-doc-name";
  SiteIndexProgressDataHooks["IndexingProgressText"] = "site-index-progress-indexing-progress-text";
  SiteIndexProgressDataHooks["IndexingTableFootnote"] = "site-index-progress-indexing-table-footnote";
  return SiteIndexProgressDataHooks;
}({});
//# sourceMappingURL=site-index-progress.data-hooks.js.map